/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloseConnectionRelation
 */
export interface CloseConnectionRelation {
    /**
     * 
     * @type {string}
     * @memberof CloseConnectionRelation
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CloseConnectionRelation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CloseConnectionRelation
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof CloseConnectionRelation
     */
    last_name: string;
}

/**
 * Check if a given object implements the CloseConnectionRelation interface.
 */
export function instanceOfCloseConnectionRelation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;

    return isInstance;
}

export function CloseConnectionRelationFromJSON(json: any): CloseConnectionRelation {
    return CloseConnectionRelationFromJSONTyped(json, false);
}

export function CloseConnectionRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseConnectionRelation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
    };
}

export function CloseConnectionRelationToJSON(value?: CloseConnectionRelation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

